import {Action, createReducer} from "@ngrx/store";

export interface State {
}

export const initialState: State = {

}

const auditReducer = createReducer(
  initialState,

);

export function reducer(state: State | undefined, action: Action): any {
  return auditReducer(state, action);
}
